import { Alert } from './component';


export default Alert;
